import FinalAssessmentModal from "./FinalAssessmentModal";
export default FinalAssessmentModal;
